import React, { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import TextField from '@cld/text-field';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { FolderBox } from './OpenOptions.styled';

export interface OpenOptionsFolderProps {
  folder: string;
  onApply(folder: string): void;
}
export const OpenOptionsFolder: FC<OpenOptionsFolderProps> = ({ folder, onApply }) => {
  const analytics = useAnalytics();

  const [folderName, setFolderName] = useState(folder);
  const { formatMessage } = useIntl();

  const handleChangeFolder = (event: React.KeyboardEvent) => {
    analytics('edit open console', 'filter by folder');
    if (event.key === 'Enter') {
      onApply(folderName);
    }
  };

  useEffect(() => {
    setFolderName(folder);
  }, [folder]);

  return (
    <FolderBox data-test="folder-box">
      <TextField
        type="text"
        placeholder={formatMessage(messages['demo.section.filter.folder.placeholder'])}
        value={folderName}
        onChange={setFolderName}
        data-test="folder-textfield-base"
        inputProps={{
          onKeyDown: handleChangeFolder,
          'data-test': 'folder-textfield',
        }}
      />
    </FolderBox>
  );
};
